export interface ExamAnswersStats {
	totalQuestions: number;
	correctAnswers: number;
	wrongAnswers: number;
	skippedQuestions: number;
	cancelledQuestions: number;
	score: number;
}

export interface ExamDepartmentStats extends ExamAnswersStats {
	departmentName: string;
}

export interface ExamStats extends ExamAnswersStats {
	departmentsStats: ExamDepartmentStats[];
}

export const getExamChartSegments = (stats: ExamAnswersStats) => [
	{ count: stats.correctAnswers, color: "var(--green)" },
	{ count: stats.wrongAnswers, color: "var(--red)" },
	{ count: stats.cancelledQuestions, color: "var(--black80)" },
	{ count: stats.skippedQuestions, color: "var(--primaryBlue)" },
];
